import { Icon } from "@circleco/compass/components/Icon";
import { Tooltip } from "@circleco/compass/components/Tooltip";

import { DOCK_NAV_ICON_BUTTON_CLASSES } from "@/react/components/CircleAi/Dock/constants";

import { PartnerBadgeAnimatedBorder } from "./PartnerBadgeAnimatedBorder";
import { useCirclePartnerBadge } from "./useCirclePartnerBadge";

export const CirclePartnerBadgeCollapsedIcon = () => {
  const { shouldShow, title, description, onClick } = useCirclePartnerBadge();

  if (!shouldShow) {
    return null;
  }

  return (
    <PartnerBadgeAnimatedBorder className="rounded-lg">
      <Tooltip
        content={
          <div className="flex flex-col">
            <span>{title}</span>
            <span>{description}</span>
          </div>
        }
        side="right"
      >
        <button
          type="button"
          onClick={onClick}
          aria-label={title}
          className={DOCK_NAV_ICON_BUTTON_CLASSES}
        >
          <Icon name="heart-handshake" size="md" color="primary" />
        </button>
      </Tooltip>
    </PartnerBadgeAnimatedBorder>
  );
};
